module.exports = __webpack_public_path__ + "img/login-side.f17e3578.svg";